<template>
  <v-snackbar timeout="2000" text color="red" :value="show">
    {{ message }}
    <template v-slot:action>
      <v-icon
        data-testid="error-button-close"
        small
        color="red"
        @click="$emit('close')"
      >
        mdi-close
      </v-icon>
    </template>
  </v-snackbar>
</template>
<script>
export default {
  name: 'Alert',

  props: {
    message: {
      type: String,
      default() {
        return this.$t('common.default_error')
      },
    },
    show: {
      type: Boolean,
      require: true,
      default() {
        return false
      },
    },
  },
}
</script>
